import styled from 'styled-components';

/**
 * Generic centered empty-state text.
 * Used by HelpDeskSidePanel and TicketsHistorySection.
 *
 * Accepts transient props:
 *  - $compact: boolean — smaller padding/font for inline sections
 */
const EmptyText = styled.div`
  padding: ${({ $compact }) => ($compact ? '12px 0' : '40px 20px')};
  text-align: center;
  font-size: ${({ $compact }) => ($compact ? '13px' : '14px')};
  color: ${({ theme }) => theme.colors.grey3};
`;

export default EmptyText;
